module.exports = __webpack_public_path__ + "img/Social-1000Blocks-Twitter.9bce9148.png";